export const MASCOT_EYES = [31, 69];

export const Mascot = ({ size = 48, className = "", label = "the suspects mascot", testid, fill = "#D7FF5B" }) => (
  <svg viewBox="0 0 100 106" width={size} height={size * 1.06} role="img" aria-label={label || undefined} aria-hidden={label ? undefined : true} className={className} data-testid={testid}>
    <rect x="3" y="3" width="94" height="100" rx="21" fill={fill} stroke="#111" strokeWidth="6" />
    <path d="M20 42L39 43" stroke="#111" strokeWidth="7" strokeLinecap="round" />
    <path d="M57 39L82 28" stroke="#111" strokeWidth="7" strokeLinecap="round" />
    {MASCOT_EYES.map((cx) => (
      <g key={cx}>
        <ellipse cx={cx} cy="63" rx="17" ry="11.5" fill="#fff" stroke="#111" strokeWidth="4" />
        <path d={`M${cx - 16.6} 60.7H${cx + 16.6}`} stroke="#111" strokeWidth="4.5" />
        <circle cx={cx + 7} cy="66.5" r="5.2" fill="#111" />
      </g>
    ))}
  </svg>
);

export const Loader = ({ label = "Loading" }) => (
  <div className="flex flex-col items-center justify-center gap-4 py-32" role="status" data-testid="loader">
    <Mascot size={44} className="animate-pulse" label="" />
    <span className="label text-concrete">{label}…</span>
  </div>
);
